import api from '@/api'

const getCompanyFeatures = function (org_id) {
  return api.get(`/organizations/${org_id}/features`)
}

export default {
  getCompanyFeatures
}
